import { Link } from '@adobe/react-spectrum';
import React from 'react';

import parseHTML from '../../../utils/ParseHTML';

/** @param {{children: string}} props.children */
const AutoLink = ({ children }) => {
  if (!children) return null;

  const trimmedChildren = children.trim();
  const isUrl = /^https?:\/\/[^\s]+$/.test(trimmedChildren);

  if (isUrl) {
    return (
      <Link href={trimmedChildren} target="_blank" rel="noopener noreferrer">
        {trimmedChildren}
      </Link>
    );
  }

  return parseHTML(trimmedChildren);
};

export default AutoLink;
